import React from "react";
import CortexCredentialsForm from "./CortexCredentialsForm";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import CortexConfigListing from "./CortexConfigListing";

export default function CortexPullAndPushView(props) {
    return (
      <GenericPullAndPushToolView
        {...props}
        PullCredentialForm={CortexCredentialsForm}
        PullConfigListingView={CortexConfigListing}
      />
    );
  }